import { TypeButtonGroupTabsWithoutUnresolvableLinksResponse } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import ButtonGroupTabs from './ButtonGroupTabs'
// import { A11yTextRenderer } from 'src/siteBuilder/utils/text/TextRenderer'

const ContentfulButtonGroupTabs = withContentful<TypeButtonGroupTabsWithoutUnresolvableLinksResponse['fields']>(
  ButtonGroupTabs,
  {
    sysID: (props) => props.sys.id,
    entryTitle: (props) => props.fields.entryTitle,
    buttonGroupTabs: (props) => {
      return props?.fields?.tabItems?.map((tab) => {
        const id = tab?.fields?.id?.split(' ').join('-')
        return {
          id,
          label: tab.fields.label,
          content: <BlockRenderer block={tab.fields.content} />,
        }
      })
    },
    styleVariant: (props) => props?.fields?.styleVariant,
    desktopAlignment: (props) => props?.fields?.desktopAlignment,
    mobileAlignment: (props) => props?.fields?.mobileAlignment,
    buttonWidth: (props) =>
      props?.fields?.buttonWidth?.toLowerCase() as Lowercase<
        TypeButtonGroupTabsWithoutUnresolvableLinksResponse['fields']['buttonWidth']
      >,
    buttonSize: (props) =>
      props?.fields?.buttonSize?.toLowerCase() as Lowercase<
        TypeButtonGroupTabsWithoutUnresolvableLinksResponse['fields']['buttonSize']
      >,
  }
)

export default ContentfulButtonGroupTabs
